import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

interface Props {
  channelId?: number;
}

export function useChannelMemberCount({ channelId }: Props): { count: number; loading: boolean } {
  const { data, loading } = useQuery<API.ListUsersQuery, API.ListUsersQueryVariables>(
    Queries.user.listUsers,
    {
      variables: {
        input: {
          memberOfChannelIds: isNil(channelId) ? undefined : [channelId],
          limit: 0,
          excludeSystemUsers: true,
        },
        customCacheKey: isNil(channelId) ? '' : getChannelMemberCountCacheKey(channelId),
      },
      skip: isNil(channelId),
    },
  );

  return useMemo(
    () => ({
      count: data?.listUsers?.total ?? 0,
      loading,
    }),
    [data?.listUsers?.total, loading],
  );
}

export function getChannelMemberCountCacheKey(channelId: number): string {
  return `channel-member-count-${channelId}`;
}
